import { getPlayerPageUrl } from "../../../utils/urls"
import Link from "next/link"
import React from "react"
import { LocalizedSeasonTeamPlayer } from "../../../types/seasonTeamPlayer"
import * as ImageConstants from "../../../constants/images"
import moment from "moment"
import { playerRoleToTranslation } from "../../../utils/player"
import { CountryImageName } from "@components/Country/CountryImageName"
import Image from "next/image"

export function TeamPlayers({ players }: { players: LocalizedSeasonTeamPlayer[] }) {
  const playersByRole = [1, 2, 3, 4, null]
    .map((role) => {
      return {
        role: role || "",
        name: role ? playerRoleToTranslation(role, true) : "Giocatori",
        players: players.filter((player) => player.roleId === role),
      }
    })
    .filter((players) => {
      return players.players.length > 0
    })

  return players.length > 0 ? (
    <div className="hs-block hs-persons">
      <div className="module-person">
        <table>
          <tbody>
            {playersByRole.map((players) => {
              return (
                <React.Fragment key={"group-" + players.role}>
                  <tr>
                    <th colSpan={6} className="role info-head-role">
                      {players.name}
                    </th>
                  </tr>
                  {players.players.map((player, i) => {
                    const playerData = player.player!

                    const playerUrl = getPlayerPageUrl(playerData.calciocomSlug!)

                    return (
                      <tr
                        className={`entry ${i == players.players.length - 1 ? "lastelement" : ""}`}
                        key={playerData.id}
                      >
                        <td className="team_person-shirtnumber team_person-shirtnumber-">{player.jerseyNumber}</td>
                        <td className="person-image person-image- info-person-image">
                          <Link href={playerUrl}>
                            <Image
                              src={playerData.image?.path || ImageConstants.PLAYER_MISSING_IMAGE_PATH}
                              alt={playerData.name}
                              title={playerData.name}
                              layout={"intrinsic"}
                              width={68}
                              height={68}
                            />
                          </Link>
                        </td>
                        <td className="person-name person-name-">
                          <Link href={playerUrl}>
                            <a title={playerData.name}>{playerData.name}</a>
                          </Link>
                          <br />
                          {playerData.birthday && moment(playerData.birthday).format("DD-MM-YYYY")}
                        </td>
                        <td className="team-image team-image-" />
                        <td className="team-name team-name-">
                          {playerData.country ? (
                            playerData.country && playerData.country2 ? (
                              <>
                                <CountryImageName country={playerData.country} />
                                <CountryImageName country={playerData.country2} />
                              </>
                            ) : (
                              <CountryImageName country={playerData.country} />
                            )
                          ) : (
                            <></>
                          )}
                        </td>
                      </tr>
                    )
                  })}
                </React.Fragment>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  ) : (
    <div className="live-text-default">Non ci sono dati disponibili</div>
  )
}
